// extracted by mini-css-extract-plugin
module.exports = {"description":"Title_description__j2HXS","title":"Title_title__ZTqEX","box":"Title_box__mOy2J","month":"Title_month__kmKMS","title2":"Title_title2__lbkQ_"};